<template>
	<div class="jd-system">
		<section class="jd-system__card">
			<h1>京东小程序接入</h1>
			<div>
				<svg-icon icon-class="jd-system" class="iconfont"/>
				<div>
					<h4>绑定后你可以使用OCS+统一接收与回复粉丝的私信</h4>
					<p>绑定后，京东小程序的客服消息会直接转发给OCS+，并且不影响京东客户端中正常使用私信功能</p>
				</div>
				<el-button type="primary" icon="el-icon-plus" plain size="small" @click="onBind()">绑定京东小程序</el-button>
			</div>
		</section>
		<section class="jd-system__table">
			<h1>已绑定列表</h1>
			<table-pagination v-loading="loading" ref="tableItem" pagination layout="prev,pager,next,total" :data="data"
				:column="column" :total="total" :page.sync="listQuery.page_num" :limit.sync="listQuery.page_size"
				@pagination="getList">
				<template v-slot:action="{row}">
					<el-button type="text" size="small" @click="onSetting(row)">设置</el-button>
					<el-divider direction="vertical"></el-divider>
					<el-button type="text" size="small" @click="onDelete(row)">解绑</el-button>
				</template>
			</table-pagination>
		</section>
		<bindJD ref="bindJd" @getList="getList"></bindJD>
		<!-- 设置 -->
		<setSkillgroup ref="setSkillgroup" @getList="getList"></setSkillgroup>
	</div>
</template>

<script>
	import bindJD from './bindJd.vue'
	import setSkillgroup from './setSkillgroup'
	export default {
		components:{
			bindJD,
			setSkillgroup
		},
		data() {
			return {
				loading:false,
				total: 0,
				listQuery: {
					page_num: 1,
					page_size: 10,
					data:{}
				},
				data: [],
				column: [{
						label: "京东名称",
						prop: "appName"
					},
					{
						label: "京东APPID",
						prop: "appId",
						render:(h,scope) => {
							return <el-button type="text" onClick={() => this.onBind(scope.row)}>{scope.row.appId}</el-button>
						}
					},
					{
						label: '绑定时间',
						prop: 'updateTime',
						sortable: true,
						render:(h,scope) => {
							return <span>{this.$dayjs(scope.row.updateTime).format("YYYY-MM-DD HH:mm")}</span>
						}
					},
					{
						label: "操作",
						prop: "action",
						slotScope: true,
						width: 200,
						align: "center",
						fixed:'right',
					}
				]
			}
		},
		methods: {
			getList(){
				this.loading = true;
				this.$api.apiGetJdBindLists(this.listQuery).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.data = res.list;
					this.total = res.total;
				}).catch(err => {
					this.loading = false;
				})
			} ,
			onSetting(row){
				this.$refs.setSkillgroup.openSeting(row)
			},
			onDelete(row){
				this.$confirm(`请前往京东客服帐号进行停用。解绑后，OCS+将无法收到来自京东小程序【${row.appName}】的私信，是否要解绑`, "解绑提醒", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
						center: true,
						customClass: "confirm-element-model"
					})
					.then(() => {
						this.$api.apiUnbindJdItem({
							app_id:row.appId
						}).then(res => {
							if(res.errcode == 0){
								this.$message.success("解绑成功");
								this.listQuery.page_num = 1;
								this.getList()
							}
						})
						
					})
					.catch(() => {
						this.$message.info('取消解绑')
					});
			},
			onBind(row){
				this.$refs.bindJd.openBind(row)
			}
			
		},
		created(){
			this.getList()
		}
	}
</script>

<style lang="scss" scoped>
	.jd-system {
		font-size: 14px;

		h1 {
			color: #3C4353;
			margin-bottom: 16px;
			font-size: 14px;
		}

		&__card {
			>div {
				padding: 20px 30px;
				box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.03);
				border-radius: 3px;
				border: 1px solid #DEDFDF;
				display: flex;
				align-items: center;
				position: relative;

				.iconfont {
					font-size: 40px;
					color: #337EFF;
				}

				>div {
					display: inline-block;
					margin-left: 31px;
					vertical-align: middle;

					h4 {
						color: #3C4353;
						font-weight: 500;
						margin-bottom: 16px;
					}

					p {
						color: #566980;
						font-size: 12px;
						line-height: 22px;
					}

					a {
						color: #337EFF;
					}
				}

				.el-button {
					position: absolute;
					right: 30px;
				}
			}
		}
		&__table {
			margin-top: 30px;
		}
	}
</style>
